/*
 * Created by alex@hackerbay.com on 4.1.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */


/**
 * get api url
 * @param endpoint
 * @param queryParameters
 * @returns {string}
 */
const getAPIUrl = (endpoint, queryParameters) => {
    let url = `${process.env.REACT_APP_FUNCTION_BASE_URL}${endpoint}`;
    if(queryParameters){
        return `${url}?${queryParameters}`
    }
    return url;
};


/**
 * parse url parameters
 * Reference: https://stackoverflow.com/a/8486188
 * split at chars: ? & #
 * @returns {null}
 */
const parseUrlParams = () => {

    var url = window.location.href;

    // HACK for Vodafone-URL replace second "?[S/E/B]" in URL with "&[S/E/B]"
    // http://vf-dsl-onboarding-app.fh:3000/?urlIdent=1T9999999999120?S
    url = url.replace(/\?S/, "&S");
    url = url.replace(/\?E/, "&E");
    url = url.replace(/\?B/, "&B");
    // console.log( "FNX: getArrayFromUrl: " + url);

    var question = url.indexOf("?");
    var hash = url.indexOf("#");
    if(hash==-1 && question==-1) return {};
    if(hash==-1) hash = url.length;
    var query = question==-1 || hash==question+1 ? url.substring(hash) :
    url.substring(question+1,hash);
    var result = {};
    query.split("&").forEach(function(part) {
        if(!part) return;
        part = part.split("+").join(" "); // replace every + with space, regexp-free version
        var eq = part.indexOf("=");
        var key = eq>-1 ? part.substr(0,eq) : part;
        var val = eq>-1 ? decodeURIComponent(part.substr(eq+1)) : "";
        var from = key.indexOf("[");
        if(from==-1) result[decodeURIComponent(key)] = val;
        else {
            var to = key.indexOf("]",from);
            var index = decodeURIComponent(key.substring(from+1,to));
            key = decodeURIComponent(key.substring(0,from));
            if(!result[key]) result[key] = [];
            if(!index) result[key].push(val);
            else result[key][index] = val;
        }
    });

    if(!result){
        return null;
    }

    // console.log( result );

    return result;

};


export {getAPIUrl, parseUrlParams}